import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import root from 'window-or-global';

import {isImageUrl} from '../../utils/VideoRecapUtils';

class VideoRecapSoundtrack extends React.Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    selected: PropTypes.bool.isRequired,
    clickItem: PropTypes.func.isRequired,
    handlePlay: PropTypes.func.isRequired,
  };

  state = {
    play: false,
  };

  audio = null;

  constructor(props) {
    super(props);
    const src = props.data.soundtrackFile;
    this.audio = new root.Audio(src);
  }

  togglePlay = () => {
    if (!this.state.play) {
      this.audio
        .play()
        .then(() => this.setState({play: true}))
        .catch(() => console.log('Audio file is corrupted'));
    } else {
      this.stop();
    }
  };

  stop = () => {
    this.audio.pause();
    this.setState({play: false});
  };

  render() {
    const {text, data, selected, clickItem, handlePlay} = this.props;
    const {key, soundtrackImg, soundtrackImgOverlay} = data;

    const soundtrackStyle = {
      backgroundImage: isImageUrl(soundtrackImg) ? `url(${soundtrackImg})` : soundtrackImg,
    };
    const overlayImageStyle = {
      backgroundImage: isImageUrl(soundtrackImgOverlay)
        ? `url(${soundtrackImgOverlay})`
        : soundtrackImgOverlay,
    };
    const onClickPreview = () => handlePlay(key, {togglePlay: this.togglePlay, stop: this.stop});

    return (
      <div key={key} className={classnames('cvrvItem', {selected})} style={soundtrackStyle}>
        <div className="cvrvItem-overlay" onClick={clickItem} role="presentation">
          <span
            className={classnames('cvrvItem-overlay-checkbox', {
              'icon-check': selected,
            })}></span>
          <div
            className={classnames('cvrvItem-overlay-image', {effects: this.state.play})}
            style={overlayImageStyle}></div>
        </div>
        <button className="cvrvItem-btn btn" onClick={onClickPreview}>
          <i className={this.state.play ? 'icon-close' : 'icon-play'} /> {text}
        </button>
      </div>
    );
  }
}

export default VideoRecapSoundtrack;
